import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { buildBreadcrumbList } from '../lib/structuredData';
export function PrivacybeleidPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-1984" data-mp="1f3yrc60qebjw">
      <SEO title="Privacybeleid | Noord Digital" description="Lees het privacybeleid van Noord Digital. Wij leggen uit welke gegevens wij verzamelen, hoe wij deze gebruiken en welke rechten jij hebt." canonical="https://noorddigital.nl/privacy" jsonLd={buildBreadcrumbList([{
      name: 'Privacybeleid',
      path: '/privacy'
    }])} data-id="element-1985" data-mp="1u1r62vygevx1" />
      <Header data-id="element-1986" data-mp="1ytiyzd531dqc" />

      <main className="pt-32 pb-20" data-id="element-1987" data-mp="1ytsnewahbctx">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[900px]" data-id="element-1988" data-mp="2csilof91bijv">
          <h1 className="text-4xl md:text-5xl font-bold mb-12 text-[#111827]" data-id="element-1989" data-mp="2cqfqlgt0yz8a">
            Privacybeleid: Noord Digital
          </h1>

          <div className="prose prose-lg max-w-none prose-headings:text-[#111827] prose-a:text-[#007AFF] prose-p:text-[#6B7280] prose-li:text-[#6B7280]" data-id="element-1990" data-mp="34a5swacoq12s">
            <p className="lead text-xl text-[#4B5563] mb-8" data-id="element-1991" data-mp="39aaak3pbx1ul">
              Bij Noord Digital hechten wij veel waarde aan de privacy van onze
              klanten en bezoekers. In dit privacybeleid leggen wij uit welke
              gegevens wij verzamelen, hoe wij deze gebruiken en welke rechten
              jij hebt.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1992" data-mp="3s6jkqfx4189b">
              Welke gegevens verzamelen wij?
            </h2>
            <p data-id="element-1993" data-mp="tyog1mg3zsy">
              Wanneer je ons contactformulier invult of reageert op een
              advertentie, kunnen wij de volgende gegevens verzamelen:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-1994" data-mp="9tu1yd3h46w5">
              <li data-id="element-1995" data-mp="9rhczfzasw9l">Naam</li>
              <li data-id="element-1996" data-mp="es5bempuwfdu">Bedrijfsnaam (optioneel)</li>
              <li data-id="element-1997" data-mp="esyad1ikq0lf">E-mailadres</li>
              <li data-id="element-1998" data-mp="2avjjgzc4fqgw">Telefoonnummer</li>
            </ul>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1999" data-mp="2awcvaepxt65w">
              Waarom verzamelen wij deze gegevens?
            </h2>
            <p data-id="element-2000" data-mp="26rvd2jz870x8">Wij gebruiken je gegevens uitsluitend om:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-2001" data-mp="2kmehf0yqcei6">
              <li data-id="element-2002" data-mp="2fumr8rjhkask">
                Contact met je op te nemen naar aanleiding van je aanvraag.
              </li>
              <li data-id="element-2003" data-mp="2uj12nquyx7kq">Je van informatie te voorzien over onze diensten.</li>
              <li data-id="element-2004" data-mp="2uldju1swjdwq">Een mogelijke samenwerking op te starten.</li>
            </ul>
            <p data-id="element-2005" data-mp="2pk6ba0ixqap0">
              Wij gebruiken jouw gegevens niet voor andere doeleinden en wij
              verkopen jouw gegevens nooit aan derden.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-2006" data-mp="2ym76krulymo1">
              Hoelang bewaren wij jouw gegevens?
            </h2>
            <p data-id="element-2007" data-mp="196pta69qp9fs">
              Wij bewaren je gegevens zolang dat nodig is om contact met je te
              onderhouden en maximaal 12 maanden na het laatste contactmoment,
              tenzij je ons vraagt om je gegevens eerder te verwijderen.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-2008" data-mp="3ktt1eo4ksltc">
              Delen van gegevens
            </h2>
            <p data-id="element-2009" data-mp="3713g6lwvfkxa">
              Wij delen jouw gegevens niet met derden, behalve wanneer dit
              wettelijk verplicht is.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-2010" data-mp="3b1nehst6kul0">Jouw rechten</h2>
            <p data-id="element-2011" data-mp="2x2dxiqx5hwfz">Je hebt het recht om:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-2012" data-mp="3231xw379rpmv">
              <li data-id="element-2013" data-mp="324mqvodxr0im">Je gegevens in te zien.</li>
              <li data-id="element-2014" data-mp="2o3k4tbmxxq7p">Je gegevens te laten corrigeren of verwijderen.</li>
              <li data-id="element-2015" data-mp="2o5ddsxl10miv">Je toestemming in te trekken.</li>
            </ul>
            <p data-id="element-2016" data-mp="2s5ni85t674vm">
              Hiervoor kun je contact met ons opnemen via:{' '}
              <a href="mailto:info@noorddigital.nl" data-id="element-2017" data-mp="mbnu248lkkdz">info@noorddigital.nl</a>
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-2018" data-mp="qe0uqe8hls3w">Contact</h2>
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-100 mt-6" data-id="element-2019" data-mp="1muzflxrs105">
              <p className="font-semibold text-[#111827] mb-1" data-id="element-2020" data-mp="1ks9f1wma7vf">Noord Digital</p>
              <p className="mb-1" data-id="element-2021" data-mp="3stpcki5r0vxl">Nieuwestad 132C</p>
              <p className="mb-0" data-id="element-2022" data-mp="3ntjspo5q0dq2">
                E-mail:{' '}
                <a href="mailto:info@noorddigital.nl" data-id="element-2023" data-mp="3nw5ypjcyql66">info@noorddigital.nl</a>
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2024" data-mp="3eug8uhyqbuai" />
    </div>;
}